module.exports = __webpack_public_path__ + "static/media/front.3065e56a.jpg";